import { NgModule } from "@angular/core";
import { WholeNumberToDecimalPipe } from "./whole-number-to-decimal-number.pipe";
import { DatePipe, DecimalPipe } from "@angular/common";
import { CustomDatePipe, FindDuplicatePipe, FormatNumberPipe, PhoneMaskPipe, TimeFormatPipe } from ".";
import { CanDeactivateGuard } from "../services/authguards/can-deactivate-route.authguard";

@NgModule({
  declarations: [PhoneMaskPipe,FindDuplicatePipe, WholeNumberToDecimalPipe,FormatNumberPipe,TimeFormatPipe, CustomDatePipe],
  providers: [CanDeactivateGuard, DatePipe, DecimalPipe, FindDuplicatePipe,
    { provide: DatePipe, useClass: CustomDatePipe },
  ],
  exports: [PhoneMaskPipe,FindDuplicatePipe, WholeNumberToDecimalPipe,FormatNumberPipe,TimeFormatPipe, CustomDatePipe],
})
export class AllPipesModule { }